import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api, setToken } from '../../api/client';
import { useAuth, HOME_FOR_ROLE } from '../../context/AuthContext';
import { Button, Field } from '../../components/ui';
import { useToast } from '../../components/Toast';
import BrandMark from '../../components/BrandMark';

export default function ResetPassword() {
  const { t } = useTranslation();
  const toast = useToast();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [busy, setBusy] = useState(false);

  async function submit(event) {
    event.preventDefault();
    if (form.password !== form.confirm) {
      toast.error(t('auth.resetPassword.passwordMismatch'));
      return;
    }
    setBusy(true);
    try {
      const session = await api.post('/api/auth/reset-password', { token, password: form.password });
      setToken(session.token);
      setUser(session.user);
      navigate(HOME_FOR_ROLE[session.user.role] || '/', { replace: true });
    } catch (err) {
      toast.error(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <Link to="/" className="auth-brand">
          <BrandMark />
          <strong>Nannies to the Rescue</strong>
        </Link>

        {token ? (
          <>
            <h1>{t('auth.resetPassword.title')}</h1>
            <p className="muted">{t('auth.resetPassword.lede')}</p>
            <form onSubmit={submit} noValidate>
              <Field label={t('auth.resetPassword.newPassword')} required hint={t('auth.resetPassword.passwordHint')}>
                <input
                  type="password"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  autoComplete="new-password"
                  minLength={8}
                  required
                />
              </Field>
              <Field label={t('auth.resetPassword.confirmNewPassword')} required>
                <input
                  type="password"
                  value={form.confirm}
                  onChange={(e) => setForm({ ...form, confirm: e.target.value })}
                  autoComplete="new-password"
                  required
                />
              </Field>
              <Button type="submit" loading={busy}>{t('auth.resetPassword.saveAndSignIn')}</Button>
            </form>
          </>
        ) : (
          <>
            <h1>{t('auth.resetPassword.incompleteTitle')}</h1>
            <p className="muted">{t('auth.resetPassword.incompleteBody')}</p>
            <Link className="btn btn-primary btn-block" to="/forgot-password">{t('auth.resetPassword.requestNewLink')}</Link>
          </>
        )}
      </div>
    </div>
  );
}
